<template>
  <div>
    <v-hover class="mb-4">
      <template v-slot="{hover}">
        <v-row align="center" justify="center" class="ma-0">
          <video
            ref="video"
            class="half-radius black"
            :src="src"
            @timeupdate="onProgress"
            @waiting="onWaiting"
            @canplay="onCanplay"
            @loadedmetadata="onLoaded"
            @dblclick="fullWindow"
            style="max-height: 50vh;"
          />
          <v-fade-transition>
            <app-button
              v-if="hover && !waiting"
              class="absolute"
              :hover="hover"
              :icon="icon"
              @click.native="onClick"
            />
            <v-progress-circular
              v-else-if="waiting"
              color="#3b2658"
              size="48"
              indeterminate
              class="absolute"
            />
          </v-fade-transition>
        </v-row>
      </template>
    </v-hover>
    <div class="color-3b2658 px-5 pb-6 pt-3 half-radius">
      <v-row align="end" class="flex-nowrap px-3">
        <app-progress-bar
          v-model="progress"
          video
          background="white"
          :duration="video && video.duration ?video.duration :0"
          @input="onInput"
        />
        <v-icon
          color="white"
          right
          size="24"
          @click="fullWindow"
          style="margin-bottom: -8px"
        >mdi-arrow-expand-all</v-icon>
      </v-row>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Button from './Button.vue';
import ProgressBar from './ProgressBar';

export default {
  components: {
    appButton: Button,
    appProgressBar: ProgressBar,
  },
  props: {
    src: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      video: {},
      icon: 'mdi-play',
      progress: 0,
      waiting: true,
    };
  },
  methods: {
    onInput() {
      this.video.currentTime = this.progress;
    },
    onClick() {
      if (this.video.paused || this.video.ended) {
        this.icon = 'mdi-pause';
        this.video.play();
      } else {
        this.icon = 'mdi-play';
        this.video.pause();
      }
    },
    onLoaded() {
      this.video = this.$refs['video'];
    },
    onProgress() {
      this.progress = this.video.currentTime;
      if (this.video.currentTime === this.video.duration) {
        this.icon = 'mdi-play';
        this.progress = 0;
      }
    },
    onCanplay() {
      this.waiting = false;
    },
    onWaiting() {
      this.waiting = true;
    },
    fullWindow() {
      this.video.requestFullscreen();
    },
  },
};
</script>
<style scoped>
video {
  width: 100%;
}
.color-3b2658 {
  background-color: #3b2658;
}
</style>